import { Component, EventEmitter, Input, OnInit, Output, NgModule, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';

@Component({
  selector: 'emptyNess',
  templateUrl: '../sharedTemplates/empty.component.html',
})
export class EmptyComponent {
  @Input() line = '';
  @Input() subLine = '';
  @Input() svgIcon = 'empty.svg';
  @Input() buttonText = '';
  @Input() buttonNavigate = '';

  constructor(public _DataHelper: DataHelper, private _router: Router) {}

  onClick() {
    if (this.buttonNavigate !== '') {
      this._router.navigate([this.buttonNavigate]);
    }
  }
}
